<template>
	<v-layout 
		row 
		wrap 
		class="form-simulator form-simulator-new"
		:class="{ 'quinti': isQinti || isLucky}">
		<v-flex xs12>
			<v-layout row wrap class="form-simulator-container">
				<v-flex xs12 v-if="step === 2">
					<v-layout class="form-simulator-type">
						<v-flex xs6>
							<v-layout justify-center class="content-type" @click="changeType(1)">
								<v-flex xs3>
									<div 
										class="circle-not-active"
										:class="{'circle-active': type === 1}">
										<img src="/static/images-new/banners/user.svg" alt="">
									</div>
								</v-flex>
								<v-flex xs5>
									<span :class="{'text-active': type === 1}">Soy una <br>persona</span>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6>
							<v-layout justify-center class="content-type" @click="changeType(2)">
								<v-flex xs3>
									<div 
										class="circle-not-active"
										:class="{'circle-active': type === 2}">
										<img src="/static/images-new/banners/shop.svg" alt="">
									</div>
								</v-flex>
								<v-flex xs5>
									<span :class="{'text-active': type === 2}">Soy una <br>empresa</span>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 class="form-simulator-input" v-if="step === 1">
					<app-input
						label="Nombres*"
						model="name"
						:value="form.name"
						@input="$emit('get-data', $event)"
					></app-input>
				</v-flex>
				<v-flex xs12 class="form-simulator-input" v-if="step === 1">
					<app-input
						label="Apellidos*"
						model="surName"
						:value="form.surName"
						@input="$emit('get-data', $event)"
					></app-input>
				</v-flex>
				<v-flex xs4 class="form-simulator-input" v-if="false">
					<app-select
						:items="documentTypes"
						item-text="name"
						item-value="id"
						model="flagTypePerson"
						return-object
						:value="form.flagTypePerson"
						border-total
						:title="documentSelected.name"
						@input="$emit('get-data', $event)"
					></app-select>
				</v-flex>
				<v-flex xs8 pl-2 text-xs-left class="form-simulator-input" v-if="false">
					<app-input
						label="Nro. de documento"
						model="documentNumber"
						:value="form.documentNumber"
						@input="$emit('get-data', $event)"
					></app-input>
					<span class="error--text caption" v-if="documentValidation">
						{{ validationMessage }}
					</span>
				</v-flex>
				<v-flex xs12 class="form-simulator-input" v-if="step === 2">
					<app-select
						:items="items"
						item-text="name"
						item-value="id"
						label="Rubro*"
						model="itemId"
						:value="form.itemId"
						@input="$emit('get-data', $event)"
					></app-select>
				</v-flex>
				<v-flex xs class="form-simulator-input" v-if="false">
					<app-select
						:items="listPlans"
						item-text="name"
						item-value="code"
						label="Plan"
						model="typePlan"
						:value="form.typePlan"
						@input="$emit('get-data', $event)"
					></app-select>
				</v-flex>
				<v-flex xs4 class="form-simulator-input" v-if="step === 1">
					<v-select
						label="Tu país"
						model="codePhone"
						item-text="value"
						item-value="value"
						:items="countries"
						hide-details
						single-line
						:value="codePhone"
						@change="$emit('get-data', { model: 'codePhone', value: $event })"
					>
						<template slot="selection" slot-scope="data">
							<div>
								<img 
									:src="data.item.image" 
									:alt="data.item.name"
									height="20">
								<span>{{data.item.value}}</span>
							</div>
						</template>
						<template slot="item" slot-scope="data">
							<div>
								<img 
									:src="data.item.image" 
									:alt="data.item.name"
									height="20">
								<span>{{data.item.value}}</span>
							</div>
						</template>
					</v-select>
				</v-flex>
				<v-flex xs8 class="form-simulator-column form-simulator-input" v-if="step === 1" pl-2>
					<app-input
						label="Celular*"
						model="phone"
						type="tel"
						:value="form.phone"
						@input="$emit('get-data', $event)"
					></app-input>
					<span class="error--text caption" v-if="phoneInvalid">
						{{ phoneMessage }}
					</span>
				</v-flex>
				<v-flex xs12 text-xs-left class="form-simulator-input" v-if="step === 1">
					<app-input
						label="Correo electrónico*"
						model="email"
						type="email"
						:value="form.email"
						@input="$emit('get-data', $event)"
					></app-input>
					<span class="error--text caption" v-if="emailValidation">
						Ingresa un correo válido
					</span>
				</v-flex>
				<v-flex xs12 class="form-simulator-input" v-if="step === 1">
					<app-input
						label="Contraseña*"
						model="password"
						type="password"
						:value="form.password"
						@input="$emit('get-data', $event)"
					></app-input>
				</v-flex>
				<v-flex xs12 class="form-simulator-input" v-if="step === 2">
					<app-input
						:label="labelDocument"
						model="documentNumber"
						:value="form.documentNumber"
						@input="$emit('get-data', $event)"
					></app-input>
				</v-flex>
				<v-flex xs12 class="form-simulator-input" v-if="step === 2">
					<app-input
						label="Nombre de comercio*"
						model="commerceName"
						:value="form.commerceName"
						@input="$emit('get-data', $event)"
					></app-input>
				</v-flex>
				<v-flex xs12 class="form-simulator-input" v-if="step === 2">
					<app-select
						:items="itemsDepartaments"
						item-text="name"
						item-value="id"
						label="Departamento*"
						model="departmentId"
						:value="form.departmentId"
						@input="$emit('get-data', $event)"
					></app-select>
				</v-flex>
				<v-flex xs12 class="form-simulator-input" v-if="false">
					<app-select
						:items="itemsProvinces"
						item-text="name"
						item-value="id"
						label="Provincia*"
						model="provinceId"
						:value="form.provinceId"
						:disabled="!form.departmentId"
						@input="$emit('get-data', $event)"
					></app-select>
				</v-flex>
				<v-flex v-if="step === 2" mt-3>
					<v-layout>
						<v-flex xs7 text-xs-left>
							<span class="text-fac">¿Tienes Facturación <br/>Electrónica?</span>
						</v-flex>
						<v-flex xs5 class="layout justify-space-around">
							<button 
								class="btn-fac"
								@click="$emit('change-bill', true)"
								:class="{ 'btn-white': form.flagBilling }">SI</button>
							<button 
								class="btn-fac"
								@click="$emit('change-bill', false)"
								:class="{ 'btn-white': !form.flagBilling }">NO</button>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	import appInput from '@/components/home/form/app-input';
	import appSelect from '@/components/home/form/app-select';

	function showPlan() {
		if (this.$route.query.plan) {
			return Boolean(this.$route.query.plan);
		}
		return false;
	}

	function isQinti() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'QINTI';
		}
		return false;
	}

	function isLucky() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'LUCKY';
		}
		return false;
	}

	function changeType(value) {
		this.type = value;
		this.labelDocument = value === 1 ? 'Número de Documento*' : 'RUC*';
	}

	function data() {
		return {
			countries: [
				{
					id: 1,
					value: '+51',
					name: 'Perú',
					image: '/static/images-new/banners/peru.svg',
					phone: '51',
				},
				{
					id: 2,
					value: '+593',
					name: 'Ecuador',
					image: '/static/images-new/banners/ecuador.svg',
					phone: '593',
				},
			],
			type: 1,
			labelDocument: 'Número de Documento*',
		};
	}

	export default {
		name: 'form-simulator',
		data,
		components: {
			appInput,
			appSelect,
		},
		computed: {
			showPlan,
			isQinti,
			isLucky,
		},
		methods: {
			changeType,
		},
		props: {
			codePhone: String,
			documentSelected: {
				default: () => {},
				type: Object,
			},
			documentTypes: {
				default: () => [],
				type: Array,
			},
			documentValidation: {
				default: true,
				type: Boolean,
			},
			emailValidation: {
				default: false,
				type: Boolean,
			},
			form: {
				default: () => {},
				type: Object,
			},
			items: {
				default: () => [],
				type: Array,
			},
			phoneInvalid: {
				default: true,
				type: Boolean,
			},
			phoneMessage: String,
			validated: {
				default: false,
				type: Boolean,
			},
			validationMessage: String,
			listPlans: {
				default: () => [],
				type: Array,
			},
			step: Number,
			itemsDepartaments: {
				default: () => [],
				type: Array,
			},
			itemsProvinces: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.form-simulator {
		padding: 5px 0px 137px;
		position: relative;
		z-index: 1;

		@media (min-width: 936px) {
			min-height: 604px;
			padding: 30px 0px 137px;
		}

		&-btn {
			border-radius: 4px !important;
			bottom: 0px;
			font-size: size(medium) !important;
			height: 29px !important;
			margin: auto;
			position: absolute;
			right: 0px;
			top: 0px;
			width: 75px !important;
		}

		&-column {
			position: relative;
			text-align: left;
		}

		&-input {
			@media (min-width: 936px) {
				margin-bottom: 8px;
			}
		}

		&-icon {
			position: absolute;
			right: 0px;
			top: 20px;
		}

		&-container {
			max-height: 505px;
			overflow: auto;
			padding: 20px 24px 30px;
			z-index: 1;
		}
	}

	.show-form {
		.form-simulator-container {
			// min-height: 338px;
			max-height: calc(100vh - 207px);

			@media (min-width: 936px) {
				max-height: calc(100vh - 230px);
			}
		}
	}

	.text-fac {
		color: color(primary);
		font-size: 14px;
		font-weight: 700;
	}

	.btn-fac {
		border: 1px solid color(primary);
		border-radius: 50%;
		color: color(primary);
		font-weight: 700;
		height: 41px;
		width: 41px;
	}

	.btn-white {
		background-color: color(primary);
		color: color(white);
	}

	.form-simulator-type {
		color: color(newaccent);
	}

	.circle-not-active {
		align-items: center;
		background-color: color(newaccent);
		border-radius: 50%;
		display: flex;
		height: 35px;
		justify-content: center;
		width: 35px;
	}

	.circle-active {
		background-color: color(newprimary);
	}

	.text-active {
		color: color(newprimary);
	}

	.content-type {
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/simulator-new/form-simulator-new.vue